import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { addDays } from 'date-fns';
import { path } from 'ramda';

import {
  getHuggg,
  getRedeemedSegment,
  getVouchers,
  getVoucherExpiry,
  isTestHuggg,
  isTestHugggRedeemed,
  redeemTestHuggg,
  shouldHideProductImageOnVoucherClaimed,
  sendHugggQREmail,
  isBlueHuggg,
  hasVoucherToClaim,
  hasFulfilledVoucher,
  isVirginExperience
} from 'redux/modules/huggg';
import { getBrand } from 'redux/modules/brand';
import {
  clearError as clearVoucherError,
  generate as generateVoucher,
  getError,
  getIsGenerating
} from 'redux/modules/voucher';
import { getRedemptionMethodID } from 'utilities/redemption';

import Voucher from './Voucher';
import {
  getDefaultSegmentTerritory,
  getIsFormRedemptionType,
  getIsPin4Type,
  getIsPrepaidCardType,
  getSelectedSegment
} from 'redux/modules/selectedSegment';
import VoucherClaimed from './VoucherClaimed';

export class VoucherContainer extends Component {
  constructor() {
    super();

    this.onSegmentConfirm = this.onSegmentConfirm.bind(this);
  }

  onSegmentConfirm(segment, data = undefined) {
    const { huggg, onConfirm } = this.props;

    if (onConfirm) {
      onConfirm();
    }

    if (this.props.isTestHuggg) {
      this.props.redeemTestHuggg();
    }

    this.props.clearVoucherError();
    this.props.generateVoucher(
      huggg.id,
      segment?.id,
      getRedemptionMethodID(huggg),
      data
    );
  }

  /**
   * The expiry date provided by the API in V2 doesn't actually provide a time,
   * which makes the expiry incorrect. The date provided is actually the
   * final day. To make this work, we have to modify the date and add an extra
   * day to it. Confusing.
   *
   * @var {Date} expiryDate
   */
  getExpiryDate() {
    return addDays(new Date(this.props.huggg.expiry_date), 1);
  }

  getBrandLocation() {
    const { brand, huggg, voucher } = this.props;

    return [
      brand.name,
      path(['segment', 'name'], voucher) || path(['segment', 'name'], huggg)
    ].join(' ');
  }

  render() {
    const {
      clearVoucherError,
      generateVoucher,
      selectedSegment,
      isBlueHuggg,
      isRedeemed,
      ...rest
    } = this.props;

    if (isRedeemed) {
      return (
        <VoucherClaimed
          isBlueHuggg={isBlueHuggg}
          onFulfil={this.onSegmentConfirm}
          {...rest}
        />
      );
    }

    return (
      <Voucher
        selectedSegment={selectedSegment}
        brandLocation={this.getBrandLocation()}
        expiryDate={this.getExpiryDate()}
        onSegmentConfirm={this.onSegmentConfirm}
        {...rest}
      />
    );
  }
}

VoucherContainer.propTypes = {
  brand: PropTypes.object,
  clearVoucherError: PropTypes.func.isRequired,
  generateVoucher: PropTypes.func.isRequired,
  huggg: PropTypes.object.isRequired,
  isTestHuggg: PropTypes.bool.isRequired,
  isTestHugggRedeemed: PropTypes.bool.isRequired,
  redeemTestHuggg: PropTypes.func.isRequired,
  redeemedSegment: PropTypes.object,
  selectedSegment: PropTypes.object,
  voucher: PropTypes.object,
  voucherExpiry: PropTypes.string,
  onConfirm: PropTypes.func,
  onSendQRCodeEmail: PropTypes.func,
  isBlueHuggg: PropTypes.bool.isRequired,
  isRedeemed: PropTypes.bool,
  isVirginExperience: PropTypes.bool
};

const mapStateToProps = state => {
  const huggg = getHuggg(state);

  return {
    brand: getBrand(state),
    selectedSegment: getSelectedSegment(state),
    isFormRedemptionType: getIsFormRedemptionType(state),
    isPin4Type: getIsPin4Type(state),
    isPrepaidCardType: getIsPrepaidCardType(state),
    defaultTerritory: getDefaultSegmentTerritory(state),
    isGenerating: getIsGenerating(state),
    isTestHuggg: isTestHuggg(state),
    isTestHugggRedeemed: isTestHugggRedeemed(state),
    vouchers: getVouchers(state),
    voucherError: getError(state),
    voucherExpiry: getVoucherExpiry(state),
    hideProductImage: shouldHideProductImageOnVoucherClaimed(state),
    redeemedSegment: getRedeemedSegment(state),
    isBlueHuggg: isBlueHuggg(state),
    huggg,
    hasVoucherToClaim: hasVoucherToClaim(state),
    hasFulfilledVoucher: hasFulfilledVoucher(state),
    isVirginExperience: isVirginExperience(state)
  };
};

export default connect(mapStateToProps, {
  clearVoucherError,
  generateVoucher,
  redeemTestHuggg,
  onSendQRCodeEmail: sendHugggQREmail
})(VoucherContainer);
